(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
function balanceReviewImages() {
  document.querySelectorAll('.balance-review-images').forEach((data) => {
    const root = document.getElementById(data.dataset.section);
    if (!root || root.dataset.balanceReviewObserver) return;
    root.dataset.balanceReviewObserver = 'true';
    const sources = JSON.parse(data.textContent);
    const update = () => root.querySelectorAll('.jdgm-carousel-item__product').forEach((link) => {
      const source = sources[link.getAttribute('href').split('#')[0]];
      const image = link.querySelector('img');
      if (!source || !image || image.dataset.balanceLargeImage) return;
      image.dataset.balanceLargeImage = 'true';
      image.setAttribute('data-src', source);
      image.setAttribute('data-src-retina', source);
      image.src = source;
    });
    update();
    new MutationObserver(update).observe(root, { childList: true, subtree: true });
  });
}
balanceReviewImages();
document.addEventListener('shopify:section:load', balanceReviewImages);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balance-cafe-story"] && !Shopify.designMode) return;
  try {
    
function bindCafeGalleries(root) {
  root.querySelectorAll('[data-cafe-gallery]').forEach(gallery => {
    if (gallery.dataset.galleryBound) return;
    gallery.dataset.galleryBound = 'true';
    const track = gallery.querySelector('.cafe-story__interior-track');
    if (!track) return;
    const autoplay = gallery.hasAttribute('data-cafe-autoplay');
    function advance(direction) {
      const item = track.querySelector('li');
      if (!item) return;
      const step = item.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      const end = track.scrollWidth - track.clientWidth;
      if (autoplay && direction > 0 && track.scrollLeft >= end - 2) track.scrollTo({left: 0});
      else if (autoplay && direction < 0 && track.scrollLeft <= 2) track.scrollTo({left: end});
      else track.scrollBy({left: direction * step});
    }
    gallery.querySelectorAll('[data-gallery-direction]').forEach(button => {
      button.addEventListener('click', () => advance(Number(button.dataset.galleryDirection)));
    });
    if (!autoplay) return;
    const toggle = gallery.querySelector('[data-gallery-autoplay-toggle]');
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let hovered = false;
    let focused = false;
    function updateToggle() {
      toggle.textContent = paused ? 'Play' : 'Pause';
      toggle.setAttribute('aria-label', paused ? 'Start automatic slideshow' : 'Pause automatic slideshow');
    }
    updateToggle();
    toggle.addEventListener('click', () => { paused = !paused; updateToggle(); });
    gallery.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovered = true; });
    gallery.addEventListener('pointerleave', () => { hovered = false; });
    gallery.addEventListener('focusin', () => { focused = true; });
    gallery.addEventListener('focusout', event => { focused = gallery.contains(event.relatedTarget); });
    const timer = window.setInterval(() => {
      if (!gallery.isConnected) { window.clearInterval(timer); return; }
      const rect = gallery.getBoundingClientRect();
      if (!paused && !hovered && !focused && !document.hidden && rect.bottom > 0 && rect.top < window.innerHeight) advance(1);
    }, 4000);
  });
}
bindCafeGalleries(document);
document.addEventListener('shopify:section:load', event => bindCafeGalleries(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balance-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('[data-balance-calculator]').forEach((root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const form = root.querySelector('form');
      const copy = JSON.parse(root.querySelector('[data-calculator-copy]').textContent);
      const results = root.querySelector('[data-results]');
      const error = root.querySelector('[data-error]');
      const input = (name) => form.elements.namedItem(name);
      const number = (name) => {
        const field = input(name);
        return field.value.trim() === '' ? NaN : field.valueAsNumber;
      };
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { maximumFractionDigits: 0 });
      const round = (value) => Math.round(value / 50) * 50;
      const clear = () => {
        results.hidden = true;
        error.hidden = true;
        error.textContent = '';
      };
      const showError = (key, field) => {
        clear();
        error.textContent = copy[key];
        error.hidden = false;
        if (field) input(field).focus();
      };
      const applyUnits = (kind, convert) => {
        const metric = input(kind + '_units').value === 'metric';
        if (convert && kind === 'height') {
          if (metric) {
            const feet = number('ft');
            const inches = number('inch');
            input('height').value = Number.isFinite(feet + inches) && Number.isInteger(feet) && feet >= 0 && inches >= 0 && inches < 12 ? Math.round((feet * 12 + inches) * 2.54 * 10) / 10 : '';
          } else {
            const height = number('height');
            const inches = Math.round(height / 2.54 * 10) / 10;
            input('ft').value = Number.isFinite(height) ? Math.floor(inches / 12) : '';
            input('inch').value = Number.isFinite(height) ? Math.round((inches % 12) * 10) / 10 : '';
          }
        }
        if (convert && kind === 'weight') {
          if (metric) {
            const stone = number('stone');
            const pounds = number('lb');
            input('weight').value = Number.isFinite(stone + pounds) && Number.isInteger(stone) && stone >= 0 && pounds >= 0 && pounds < 14 ? Math.round((stone * 14 + pounds) * 0.45359237 * 10) / 10 : '';
          } else {
            const weight = number('weight');
            const pounds = Math.round(weight / 0.45359237 * 10) / 10;
            input('stone').value = Number.isFinite(weight) ? Math.floor(pounds / 14) : '';
            input('lb').value = Number.isFinite(weight) ? Math.round((pounds % 14) * 10) / 10 : '';
          }
        }
        root.querySelectorAll('[data-' + kind + '-fields]').forEach((group) => {
          const active = group.getAttribute('data-' + kind + '-fields') === (metric ? 'metric' : 'imperial');
          group.hidden = !active;
          group.querySelectorAll('input').forEach((field) => { field.disabled = !active; });
        });
      };
      form.addEventListener('input', clear);
      form.addEventListener('change', (event) => {
        clear();
        if (event.target.name === 'height_units') applyUnits('height', true);
        if (event.target.name === 'weight_units') applyUnits('weight', true);
        if (event.target.name === 'activity') {
          const description = root.querySelector('[data-activity-description]');
          const selected = event.target.selectedOptions[0].dataset.description;
          description.textContent = selected ? copy['activity_desc_' + selected] : '';
          description.hidden = !selected;
        }
      });
      form.addEventListener('reset', () => {
        clear();
        requestAnimationFrame(() => {
          applyUnits('height', false);
          applyUnits('weight', false);
          root.querySelector('[data-activity-description]').hidden = true;
          root.querySelector('[data-activity-description]').textContent = '';
        });
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        clear();
        const age = number('age');
        if (!Number.isInteger(age) || age < 18 || age > 100) return showError('invalid_age', 'age');
        const sex = input('sex').value;
        const activity = Number(input('activity').value);
        const goal = input('goal').value;
        if (!['female', 'male'].includes(sex) || ![1.2, 1.375, 1.55, 1.725, 1.9].includes(activity) || !['maintain', 'lose', 'muscle'].includes(goal) || !input('eligible').checked) return showError('invalid_choices');
        let height;
        let weight;
        if (input('height_units').value === 'metric') {
          height = number('height');
        } else {
          const feet = number('ft');
          const inches = number('inch');
          if (![feet, inches].every(Number.isFinite) || !Number.isInteger(feet) || feet < 0 || inches < 0 || inches >= 12) return showError('invalid_number');
          height = (feet * 12 + inches) * 2.54;
        }
        if (input('weight_units').value === 'metric') {
          weight = number('weight');
        } else {
          const stone = number('stone');
          const pounds = number('lb');
          if (![stone, pounds].every(Number.isFinite) || !Number.isInteger(stone) || stone < 0 || pounds < 0 || pounds >= 14) return showError('invalid_number');
          weight = (stone * 14 + pounds) * 0.45359237;
        }
        if (!Number.isFinite(height) || height < 100 || height > 250) return showError('invalid_height');
        if (!Number.isFinite(weight) || weight < 30 || weight > 350) return showError('invalid_weight');
        if (weight / ((height / 100) ** 2) < 18.5) return showError('underweight');
        const resting = 10 * weight + 6.25 * height - 5 * age + (sex === 'male' ? 5 : -161);
        const maintenance = resting * activity;
        if (!Number.isFinite(maintenance) || round(maintenance) <= 1200) return showError('low_energy');
        const values = { maintain: round(maintenance), lose: round(maintenance * 0.85), muscle: round(maintenance * 1.05) };
        const lossAvailable = values.lose > 1200;
        Object.entries(values).forEach(([key, value]) => {
          const card = root.querySelector('[data-result-card="' + key + '"]');
          const unavailable = key === 'lose' && !lossAvailable;
          card.querySelector('[data-value]').textContent = unavailable ? copy.loss_unavailable : copy.approx + ' ' + format.format(value);
          card.querySelector('.balance-calculator__kcal').hidden = unavailable;
          card.querySelector('[data-card-description]').textContent = unavailable ? copy.loss_low : copy[key + '_desc'];
          card.classList.toggle('is-selected', key === goal);
          card.classList.toggle('is-unavailable', unavailable);
          card.querySelector('[data-selected]').hidden = key !== goal;
        });
        root.querySelector('[data-result-note]').textContent = goal === 'lose' ? (lossAvailable ? copy.loss_note : copy.loss_low) : copy[goal + '_note'];
        results.hidden = false;
        results.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
      applyUnits('height', false);
          applyUnits('weight', false);
      form.removeAttribute('inert');
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balance-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.balance-header__mobile nav a');
  if (link) link.closest('details').removeAttribute('open');
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.balance-header__mobile[open]');
  if (menu) {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balance-macro-finder"] && !Shopify.designMode) return;
  try {
    
function initialiseBalanceMacroFinder() {
  document.querySelectorAll('.balance-macro-finder').forEach(finder => {
    if (finder.dataset.initialised) return;
    finder.dataset.initialised = 'true';
    if (finder.dataset.enabled !== 'true') return;
    const target = document.getElementById(finder.dataset.target);
    if (!target) return;
    target.closest('.balance-products')?.classList.add('balance-products--filtered');
    const groups = [...finder.querySelectorAll('[data-nutrient]')];
    const selected = Object.fromEntries(groups.map(group => [group.dataset.nutrient, 0]));
    const cards = [...target.querySelectorAll('.balance-products__card')];
    let diet = 'all';
    const sort = finder.querySelector('[data-product-sort]');
    const minPrice = finder.querySelector('[data-price-min]');
    const maxPrice = finder.querySelector('[data-price-max]');
    const inStock = finder.querySelector('[data-in-stock]');
    const priceError = finder.querySelector('[data-price-error]');
    const clearShopping = finder.querySelector('[data-reset-shopping]');
    const grid = target.querySelector('.balance-products__grid');
    function resetShopping() {
      if (sort) sort.value = 'featured';
      if (minPrice) minPrice.value = '';
      if (maxPrice) maxPrice.value = '';
      if (inStock) inStock.checked = false;
    }
    const dietButtons = [...finder.querySelectorAll('[data-diet]')];
    const glutenNote = finder.querySelector('[data-gluten-note]');
    const sodiumNote = finder.querySelector('[data-sodium-note]');
    const limits = { protein:[30,50], calories:[500,800], carbs:[30,80], fat:[10,30] };
    function update() {
      const active = [];
      groups.forEach(group => {
        const band = selected[group.dataset.nutrient];
        group.querySelectorAll('[data-band]').forEach(button => {
          const pressed = Number(button.dataset.band) === band;
          button.setAttribute('aria-pressed', String(pressed));
          if (pressed && band !== 0) active.push(group.querySelector('legend').textContent + ': ' + button.textContent);
        });
      });
      dietButtons.forEach(button => {
        const pressed = button.dataset.diet === diet;
        button.setAttribute('aria-pressed', String(pressed));
        if (pressed && diet !== 'all') active.unshift(button.textContent);
      });
      if (glutenNote) glutenNote.hidden = diet !== 'gluten_free';
      if (sodiumNote) sodiumNote.hidden = diet !== 'low_sodium';
      const minimum = minPrice?.value === '' ? 0 : Number(minPrice?.value || 0);
      const maximum = maxPrice?.value === '' ? Infinity : Number(maxPrice?.value || Infinity);
      const validRange = Number.isFinite(minimum) && minimum >= 0 && maximum >= minimum;
      if (priceError) priceError.hidden = validRange;
      const shoppingActive = Boolean(minPrice?.value || maxPrice?.value || inStock?.checked || (sort && sort.value !== 'featured'));
      if (clearShopping) clearShopping.hidden = !shoppingActive;
      let count = 0;
      cards.forEach(card => {
        const sugarRaw = card.dataset.sugar;
        const sugar = Number(sugarRaw);
        const matchesLowSugar = sugarRaw != null && sugarRaw.trim() !== '' && Number.isFinite(sugar) && sugar >= 0 && sugar <= 5;
        const saltRaw = card.dataset.salt100g;
        const salt = Number(saltRaw);
        const matchesLowSodium = saltRaw != null && saltRaw.trim() !== '' && Number.isFinite(salt) && salt >= 0 && salt <= 0.3;
        const matchesDiet = diet === 'all' || (diet === 'low_sugar' ? matchesLowSugar : diet === 'low_sodium' ? matchesLowSodium : (card.dataset.diets || '').split(' ').includes(diet));
        const price = Number(card.dataset.price) / 100;
        const matchesPrice = !validRange || (Number.isFinite(price) && price >= minimum && price <= maximum);
        const matchesStock = !inStock?.checked || card.dataset.available === 'true';
        const matches = matchesPrice && matchesStock && matchesDiet && groups.every(group => {
          const nutrient = group.dataset.nutrient;
          const band = selected[nutrient];
          if (band === 0) return true;
          const raw = card.dataset[nutrient];
          const value = Number(raw);
          if (raw == null || raw === '' || !Number.isFinite(value)) return false;
          const [low,high] = limits[nutrient];
          return band === 1 ? value < low : band === 2 ? value >= low && value <= high : value > high;
        });
        card.hidden = !matches;
        if (matches) count++;
      });
      if (grid) {
        const order = sort?.value || 'featured';
        const position = new Map(cards.map((card,index) => [card,index]));
        const sorted = [...cards].sort((a,b) => {
          let result = 0;
          if (order === 'price-ascending') result = Number(a.dataset.price) - Number(b.dataset.price);
          if (order === 'price-descending') result = Number(b.dataset.price) - Number(a.dataset.price);
          if (order === 'created-descending') result = Number(b.dataset.created || 0) - Number(a.dataset.created || 0);
          if (order === 'title-ascending') result = (a.dataset.title || '').localeCompare(b.dataset.title || '', 'en', {sensitivity:'base'});
          return result || position.get(a) - position.get(b);
        });
        sorted.forEach(card => grid.append(card));
      }
      const results = finder.querySelector('[data-results]');
      results.textContent = count + ' ' + results.dataset.suffix;
      finder.querySelector('[data-empty]').hidden = count !== 0;
      const summary = finder.querySelector('[data-active]');
      summary.textContent = active.join(' · ');
      summary.hidden = active.length === 0;
    }
    dietButtons.forEach(button => {
      button.addEventListener('click', () => {
        diet = diet === button.dataset.diet ? 'all' : button.dataset.diet;
        update();
      });
    });
    finder.querySelectorAll('[data-band]').forEach(button => {
      button.addEventListener('click', () => {
        selected[button.closest('[data-nutrient]').dataset.nutrient] = Number(button.dataset.band);
        update();
      });
    });
    sort?.addEventListener('change', update);
    minPrice?.addEventListener('input', update);
    maxPrice?.addEventListener('input', update);
    inStock?.addEventListener('change', update);
    clearShopping?.addEventListener('click', () => { resetShopping(); update(); });
    finder.querySelector('[data-reset]').addEventListener('click', () => {
      resetShopping();
      diet = 'all';
      Object.keys(selected).forEach(nutrient => { selected[nutrient] = 0; });
      update();
    });
    update();
  });
}
initialiseBalanceMacroFinder();
document.addEventListener('shopify:section:load', initialiseBalanceMacroFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balance-shop-browser"] && !Shopify.designMode) return;
  try {
    
function initialiseBalanceShopBrowser() {
  if (window.Shopify?.designMode) return;
  document.querySelectorAll('[data-shop-browser]').forEach(browser => {
    if (browser.dataset.initialised) return;
    const catalogue = document.querySelector('#shop-meals')?.closest('.shopify-section');
    if (!catalogue) return;
    browser.dataset.initialised = 'true';
    browser.querySelector('[data-shop-catalogue]').append(catalogue);
    const finder = document.querySelector('.balance-macro-finder[data-target="shop-meals"]');
    const filters = finder?.closest('.shopify-section');
    if (filters) browser.querySelector('[data-shop-filters]').append(filters);
    const productGroups = {meals:document.getElementById('shop-meals'),treats:document.getElementById('shop-treats')};
    const samples = [...browser.querySelectorAll('[data-sample-category]')];
    const panels = {};
    ['build','doughnuts','cakes','coffee','gifts','events'].forEach(category => {
      const panel = document.getElementById('shop-' + category)?.closest('.shopify-section');
      if (panel) {
        panels[category] = [panel];
        browser.querySelector('[data-shop-information]').append(panel);
        if (category === 'build') {
          const picker = document.querySelector('[data-balance-builder]')?.closest('.shopify-section');
          if (picker) {
            panels[category].push(picker);
            browser.querySelector('[data-shop-information]').append(picker);
          }
        }
      }
    });
    const categoryLinks = [...browser.querySelectorAll('.balance-shop-browser__nav a[data-category], .balance-shop-browser__build-intro a[data-category]')];
    const select = browser.querySelector('[data-category-select]');
    const title = browser.querySelector('[data-shop-title]');
    const status = browser.querySelector('[data-shop-status]');
    browser.querySelector('.balance-shop-browser__mobile').hidden = false;
    let current;
    function showCategory(category, updateUrl) {
      if (![...select.options].some(option => option.value === category)) category = 'all';
      if (current !== category) finder?.querySelector('[data-reset]')?.click();
      current = category;
      categoryLinks.forEach(link => {
        if (link.closest('nav')) {
          if (link.dataset.category === category) link.setAttribute('aria-current','true');
          else link.removeAttribute('aria-current');
        }
      });
      select.value = category;
      title.textContent = select.selectedOptions[0].textContent;
      let count = 0;
      Object.entries(productGroups).forEach(([key, group]) => {
        if (!group) return;
        group.hidden = category !== 'all' && category !== key;
        group.querySelector('h3').hidden = category !== 'all';
        if (!group.hidden) count += group.querySelectorAll('.balance-products__card').length;
      });
      catalogue.hidden = !['all','meals','treats'].includes(category);
      if (filters) filters.hidden = category !== 'meals';
      browser.querySelector('[data-meals-intro]').hidden = category !== 'meals';
      Object.entries(panels).forEach(([key, categoryPanels]) => {
        categoryPanels.forEach(panel => { panel.hidden = category !== key; });
      });
      samples.forEach(sample => { sample.hidden = category !== 'all' && sample.dataset.sampleCategory !== category; sample.querySelector('h3').hidden = category !== 'all'; });
      status.textContent = catalogue.hidden ? browser.querySelector('[data-sample-category="' + category + '"]')?.querySelector('p')?.textContent || status.dataset.availabilityLabel : count + ' ' + status.dataset.productsLabel;
      status.hidden = category === 'meals' || catalogue.hidden;
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('category',category);
        url.hash = '';
        window.history.pushState({},'',url);
      }
    }
    categoryLinks.forEach(link => link.addEventListener('click',event => {
      event.preventDefault();showCategory(link.dataset.category,true);
      if (browser.getBoundingClientRect().top < 0) browser.scrollIntoView({block:'start',behavior:'smooth'});
    }));
    select.addEventListener('change',() => showCategory(select.value,true));
    const readCategory = () => new URL(window.location.href).searchParams.get('category') || 'all';
    window.addEventListener('popstate',() => showCategory(readCategory(),false));
    showCategory(readCategory(),false);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialiseBalanceShopBrowser);
else initialiseBalanceShopBrowser();
document.addEventListener('shopify:section:load',initialiseBalanceShopBrowser);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
